export default "__VITE_ASSET__pfvHdb8C__"